import { Path, Svg } from 'react-native-svg';

type FullLogoIconProps = {
  width?: number | string;
  height?: number | string;
  color?: string;
  showIcon?: boolean;
  showText?: boolean;
};

export const FullLogoIcon = ({
  width,
  height,
  color,
  showIcon = true,
  showText = true,
}: FullLogoIconProps) => {
  // Paths do ícone (primeiros 3 paths)
  const iconPaths = [
    'M0 141.56V92.65c0-13.33 18.48-31.76 31.35-32.71l214.22.22c34.87 5.99 43.19 54.77 14.26 75-2.28 1.59-13.01 6.4-15.13 6.4H0zM0 262.9v-48.91c0-13.33 19.4-31.76 32.92-32.71l224.92.22c36.61 5.99 45.35 54.77 14.97 75-2.39 1.59-13.66 6.4-15.89 6.4H0zM0 384.24v-48.91c0-13.33 16.32-32.71 39.29-32.71h153.44c0 7.98-.06 26.79-.03 46.55.03 21.29-22.79 35.25-41.68 35.19-22.19-.07-56.64-.13-56.84-.13H0z',
  ];

  // Paths do texto (restantes)
  const textPaths = [
    'M1983.05 351.41s-.14-20.25-.71-26.72c-100.21 84.34-223.03-29.11-176.61-140.94 42.76-103.01 227.59-102.23 240.25 24.33V352l-62.93-.58zm-77.24-183.55c-52.13 10.66-61.54 98.93-14.11 124.82 50.7 27.67 100.52-17.98 92.32-71.15-6.01-38.95-39.17-61.65-78.21-53.67zM1529.29 113.69c91.35-13.18 159.75 46.41 148.82 139.73-10.6 90.47-132.77 129.77-201.03 74.47-78.43-63.52-48.16-199.72 52.22-214.2zm21.3 57.41c-43.82 4.4-67.16 57.36-44.31 94.27 21.88 35.35 75.24 36.93 97.81 1.86 26.16-40.64-4.5-101.06-53.49-96.14zM703.14 113.15c186.51-25.23 194.52 224.21 44.6 238.45-177.15 16.83-181.94-219.87-44.6-238.45zm21.3 57.42c-42.8 4.3-65.85 55.37-45.44 92.37 20.67 37.45 75.29 39.22 98.87 3.71 26.69-40.21-4.15-101.02-53.43-96.07z',
    'M1027.97 348.63V211.99c-6.2-49.11-77.35-49.88-84.81-1.18v137.82h-63.61V115.4h60.58c1.36 0-1.02 23.88.03 27.26 41.86-50.98 143.86-27.53 154.45 46.95v159.02c0 .32-66.64 0-66.64 0zM460.82 113.16c38.99-5.62 82.37 1.04 111.41 29.37 6.32 6.16 25.49 30.97 16.55 37.99-2.23 1.75-50.33 19.79-53.17 19.72-5.67-.14-16.47-21.93-31.57-25.87-29.43-7.68-60.13 2.88-70.43 32.74-16.85 48.85 16.02 96.76 70.43 82.54 15.03-3.93 25.88-24.7 28.99-25.45 2.97-.72 55.53 17.77 57.43 20.77 4.16 6.59-4.3 16.69-8.28 22.24-49.4 68.92-167.64 56.71-204.92-18.17-34.83-69.96 3.1-164.28 83.56-175.88zM1199.82 53.36v63.33s54.52-.32 54.52 0v51.77h-54.52v107.53c.7 24.57 41.81 15.32 54.52 16.66v53.01c-6.41 5.09-22.69 6.9-31.84 7.54-109.17 7.63-90.2-93.47-90.33-169.43-.02-10.88 1.02-130.4 1.02-130.4h66.63z',
    'M1702.67 8.4H1769.3100000000002V349.15999999999997H1702.67z',
    'M1427.03 112.9v62.09c-7.23 1.3-26.77 3.65-34 5.4-18.42 4.47-38.7 23.46-38.7 43.06v125.7h-63.61V115.93l63.47-.27c1.1 0 0 21.46 0 26.35 12.79-29.72 43.41-32.02 72.83-29.11zM2899.31 114.96s4.38 217.68-9.13 262.59c-26.59 88.36-145.96 98-218.73 53.35-9.17-5.62-21.73-15.68-21.73-15.68l30.54-44.75s30.95 17.29 42.32 21.42c61.21 22.24 115.67-5.37 112.17-71.28-15.27 12.43-24.16 20.17-44.3 26.85-55.03 18.27-117.78-6.49-138.9-60.22-47-119.59 71.51-229.32 178.69-148.45 15.33 3.63 15.72-23.83 15.72-23.83h53.36zm-144.11 54.91c-71.34 12.16-67.42 125.26 11.55 126.57 88.25 1.46 87.09-143.39-11.55-126.57zM2144.33 458.41l-64.61.51 2.36-345.25c6.24-.14 58.96 1.1 58.96 1.1s-4.4 40.31 12.22 23.99c59.05-58.02 159.77-24.18 183.43 53.1 33.3 108.79-73.64 208.55-164.12 158.06-7.78-4.34-28.23-21.75-28.23-21.75v130.25zm110.42-168.27c64.49-56.45-8.84-157.55-79.98-111.77-77.01 49.57 5.64 176.85 79.98 111.77z',
    'M2549.22 351.41s-.14-20.25-.71-26.72c-100.21 84.34-223.03-29.11-176.61-140.94 42.76-103.01 227.59-102.23 240.25 24.33V352l-62.93-.58zm-77.24-183.55c-52.13 10.66-61.54 98.93-14.11 124.82 50.7 27.67 100.52-17.98 92.32-71.15-6.01-38.95-39.17-61.65-78.21-53.67z',
  ];

  // Calcula o viewBox baseado no que será exibido
  // Se só ícone: usa viewBox proporcional ao icon_logo (0 0 469.46 522.97)
  // Se só texto: usa viewBox completo mas só mostra paths do texto
  // Se ambos: viewBox completo
  let viewBox = '0 0 2901.56 458.92';

  if (showIcon && !showText) {
    // Só ícone - usa viewBox do icon_logo ajustado para manter proporção
    viewBox = '0 0 469.46 458.92';
  } else if (!showIcon && !showText) {
    // Nada a mostrar
    return null;
  }
  // Para só texto ou ambos, usa viewBox completo

  return (
    <Svg viewBox={viewBox} width={width} height={height}>
      {showIcon &&
        iconPaths.map((path, index) => <Path key={`icon-${index}`} d={path} fill={color} />)}
      {showText &&
        textPaths.map((path, index) => <Path key={`text-${index}`} d={path} fill={color} />)}
    </Svg>
  );
};
